<template>
    <v-container>
        <v-row v-if="hhServicesEnabled" text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Остатки по API</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="service.headers"
                            :items="service.data.items"
                            :loading="service.loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.service_type.name }}</td>
                                    <td class="text-left">{{ $moment(item.activated_at).format('DD.MM.YYYY HH:mm') }}</td>
                                    <td class="text-left">{{ $moment(item.expires_at).format('DD.MM.YYYY HH:mm') }}</td>
                                    <td class="text-left">{{ item.balance.initial }}</td>
                                    <td class="text-left">{{ item.balance.actual }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row text-center wrap>
            <v-col xs="12">
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Расходы компаний</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-row class="ma-0 pa-0">
                            <v-col md="2" class="ma-0 pa-0">
                                <v-menu
                                    v-model="search.menu.from_date"
                                    ref="menuFromDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="fromDate"
                                            label="Начало периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="my-0 ml-0 pl-0"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="search.filter.from_date"
                                        @change="searchStats(); search.menu.from_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="2" class="ma-0 pa-0">
                                <v-menu
                                    v-model="search.menu.till_date"
                                    ref="menuTillDate"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="tillDate"
                                            label="Окончание периода"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                            class="col-md-2 mt-0 mb-0 ml-5 pl-5"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="search.filter.till_date"
                                        @change="searchStats(); search.menu.till_date = false"
                                        locale="ru"
                                        first-day-of-week="1"
                                        color="primary"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="8">
                                <v-select
                                    v-model="search.filter.manager_id"
                                    @change="searchStats"
                                    :items="manager.search.data"
                                    :cache-items="true"
                                    clearable
                                    item-text="name"
                                    item-value="id"
                                    label="Администратор"
                                    class="pt-0 mt-0 mb-0 ml-5 pl-5"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :headers="search.headers"
                            :items="search.data"
                            :loading="search.loading"
                            disable-pagination
                            hide-default-footer
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.company.id }}</td>
                                    <td class="text-left">{{ item.company.name }}</td>
                                    <td class="text-left">{{ item.manager.name }}</td>
                                    <td class="text-left">{{ item.resume }}</td>
                                    <td class="text-left">{{ item.contact }}</td>
                                </tr>
                            </template>
                            <template slot="body.append">
                                <tr>
                                    <th colspan="3"></th>
                                    <th>{{ search.data.reduce((a, b) => a + (b.resume || 0), 0) }}</th>
                                    <th>{{ search.data.reduce((a, b) => a + (b.contact || 0), 0) }}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { hhServicesEnabled } from '../../config/features'

export default {
    name: "StatsController",
    data () {
        return {
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            search: {
                data: [],
                filter: {
                    manager_id: '',
                    from_date: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    till_date: this.$moment().format('YYYY-MM-DD'),
                },
                headers: [
                    {
                        text: 'ID',
                        value: 'company.id',
                    },
                    {
                        text: 'Компания',
                        value: 'company.name',
                    },
                    {
                        text: 'Администратор',
                        value: 'manager.name',
                    },
                    {
                        text: 'Резюме',
                        value: 'resume',
                    },
                    {
                        text: 'Контакты',
                        value: 'contact',
                    },
                ],
                loading: true,
                menu: {
                    from_date: false,
                    till_date: false,
                },
            },
            service: {
                data: [],
                headers: [
                    {
                        text: 'Услуга',
                        value: 'service_type.name',
                    },
                    {
                        text: 'Дата активации',
                        value: 'activated_at',
                    },
                    {
                        text: 'Дата окончания',
                        value: 'expires_at',
                    },
                    {
                        text: 'Начальное значение',
                        value: 'balance.initial',
                    },
                    {
                        text: 'Текущее значение',
                        value: 'balance.actual',
                    },
                ],
                loading: true,
            },
        }
    },
    computed: {
        hhServicesEnabled () {
            return hhServicesEnabled
        },
        fromDate () {
            return this.formatDate(this.search.filter.from_date)
        },
        tillDate () {
            return this.formatDate(this.search.filter.till_date)
        },
    },
    created () {
        this.searchStats()
        this.searchManagers()
        this.searchServices()
    },
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}.${month}.${year}`
        },

        searchStats () {
            this.search.loading = true

            this.$axios.post('/manager/stats/search', this.search.filter)
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },

        searchServices () {
            if (!hhServicesEnabled) {
                return
            }

            this.service.loading = true

            this.$axios.post('/manager/stats/service')
                .then(res => {
                    if (res.data.success) {
                        this.service.data = res.data.data
                    }

                    this.service.loading = false
                })
                .catch(() => {
                    this.service.loading = false
                })
        },
    },
}
</script>

<style>
a {
    text-decoration: none;
}
</style>
